// src/hooks/useFormSubmit.js
import { useState } from "react";
import axios from "axios";

// Istanza Axios con baseURL
const apiClient = axios.create({
  baseURL: "https://gestione.carellidistribuzione.it",
  // qui potresti aggiungere headers comuni, timeout, ecc.
});

export default function useFormSubmit(path, task) {
  const [formData, setFormData]    = useState({});
  const [sending, setSending]      = useState(false);
  const [resultMessage, setResult] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setResult(null);
    try {
      const payload = { task, ...formData };
      // ora basta passare il path relativo
      const response = await apiClient.post(path, payload);
      const returnedData = response.data;
      setResult({
        type: "success",
        text: "Messaggio inviato!",
        data: returnedData,
      });
      setFormData({});
    } catch (err) {
      setResult({ type: "error", text: "Errore durante l’invio." });
    } finally {
      setSending(false);
    }
  };

  return {
    formData,
    sending,
    resultMessage,
    handleChange,
    handleSubmit,
  };
}
